import React, { Component } from "react"

class Top extends Component {

    render = () => {

        const { data } = this.props

        console.log(data)

        if (!data) {
            return <div />
        }

        return (
            <div className="reviewTopRating">

                <div className="reviewRating">

                    <p className="ratingNumber">{Number(data.rating).toFixed(2)}</p>

                    <div className="reviewStars">
                        {[1, 2, 3, 4, 5].map((item, index) => {

                            if (item <= parseInt(data.rating)) {
                                return (
                                    <div className="reviewStar" key={`${index}`}>
                                        <img src="/images/star.png" alt="star" />
                                    </div>
                                )
                            }

                            if (item - parseInt(data.rating) == 1) {
                                return (
                                    <div className="reviewStar" key={`${index}`}>
                                        <img src="/images/star-gray.png" alt="star" />
                                        <div className="halfStar" style={{ width: (Number(data.rating).toFixed(2) - parseInt(data.rating)) * 18 }}>
                                            <img src="/images/star.png" alt="star" />
                                        </div>
                                    </div>
                                )
                            }

                            return (
                                <div className="reviewStar" key={`${index}`}>
                                    <img src="/images/star-gray.png" alt="star" />
                                </div>
                            )

                        })}
                    </div>
                    {parseInt(data.reviews) > 0 && <p className="review-count">{data.reviews} отзыв{parseInt(data.reviews) === 1 ? "" : parseInt(data.reviews) <= 4 ? "а" : "ов"}</p>}
                </div>

                <div className="lines">
                    {[5, 4, 3, 2, 1].map((item, index) => {

                        let percentage = 0
                        const i = data.lines.findIndex(e => parseInt(e.rate) === item)
                        if (i > -1) {
                            percentage = data.lines[i].count / data.reviews
                        }

                        return (
                            <div className="line" key={`${index}`}>

                                <div className="backline">
                                    <div className="frontline" style={{ width: `calc(100% * ${percentage})` }} />
                                </div>

                                <p>{item}</p>

                            </div>
                        )
                    })}
                </div>
            </div>
        )

    }

}

export default Top